import React from 'react';

export const SmartSuggestionIcon = () => (
  <svg viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M26.7886 15.3037H22.3508C19.2264 15.3037 16.694 12.7714 16.694 9.64702V5.20921C16.694 4.82613 16.3831 4.5127 15.9975 4.5127C15.6144 4.5127 15.301 4.82364 15.301 5.20921V9.64702C15.301 12.7714 12.7687 15.3037 9.64429 15.3037H5.20897C4.82588 15.3037 4.51245 15.6147 4.51245 16.0003C4.51245 16.3833 4.8234 16.6968 5.20897 16.6968H9.64678C12.7712 16.6968 15.3035 19.2291 15.3035 22.3535V26.7913C15.3035 27.1744 15.6144 27.4878 16 27.4878C16.3831 27.4878 16.6965 27.1769 16.6965 26.7913V22.3535C16.6965 19.2291 19.2289 16.6968 22.3532 16.6968H26.7911C27.1741 16.6968 27.4876 16.3858 27.4876 16.0003C27.4876 15.6172 27.1766 15.3037 26.7911 15.3037H26.7886Z'
      fill='#EF6706'
    />
    <path
      d='M7.94542 7.90611C8.2091 7.64243 8.64194 7.66233 8.88074 7.95089L13.0847 13.0454L7.9902 8.84144C7.70164 8.60512 7.68174 8.1698 7.94542 7.90611Z'
      fill='#EF6706'
    />
    <path
      d='M8.0399 24.0504C7.77622 23.7868 7.79612 23.3539 8.08468 23.1151L13.1792 18.9111L8.97523 24.0057C8.73891 24.2942 8.30358 24.3141 8.0399 24.0504Z'
      fill='#EF6706'
    />
    <path
      d='M24.184 23.9577C23.9203 24.2213 23.4875 24.2014 23.2487 23.9129L19.0447 18.8184L24.1392 23.0223C24.4278 23.2587 24.4477 23.694 24.184 23.9577Z'
      fill='#EF6706'
    />
    <path
      d='M24.0922 7.81139C24.3559 8.07507 24.336 8.50791 24.0474 8.74671L18.9529 12.9507L23.1569 7.85616C23.3932 7.56761 23.8285 7.54771 24.0922 7.81139Z'
      fill='#EF6706'
    />
  </svg>
);
